export const SHIPPING_ADDRESSES_FEATURE_KEY = 'shipping-addresses';
